import { CustomVizId } from 'libs/end-to-end/src/custom-viz/CustomVizId';
import { z } from 'zod';
import { MarshalledInputs } from 'libs/end-to-end/src/marshalling';
import { ObservationLocationType } from 'libs/end-to-end/src/observation-upload-type';

export const createCustomVizRequestSchema = <
  Id extends CustomVizId,
  Inputs extends z.ZodType<MarshalledInputs>,
>(
  customVizId: Id,
  inputs: Inputs,
) =>
  z.object({
    customVizId: z.literal(customVizId),
    inputs,
    organizationId: z.string(),
    observationLocationType: ObservationLocationType,
  });
